import { render, staticRenderFns } from "./AppMiniTabs.vue?vue&type=template&id=5c5bfcde&scoped=true&"
import script from "./AppMiniTabs.vue?vue&type=script&lang=js&"
export * from "./AppMiniTabs.vue?vue&type=script&lang=js&"
import style0 from "./AppMiniTabs.vue?vue&type=style&index=0&id=5c5bfcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5bfcde",
  null
  
)

export default component.exports